
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/surf-charts/location/[chartLocation]",
      function () {
        return require("private-next-pages/surf-charts/location/[chartLocation].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/surf-charts/location/[chartLocation]"])
      });
    }
  